<template>
  <div>
    <qrcode-vue
      :value="waitingListFormPath"
      :size="size"
      level="H"
      render-as="canvas"
      class="flex justify-center"
      ref="qrCodeCanvas"></qrcode-vue>

    <div class="flex justify-center mt-3 items-center">
      <p class="mr-3">{{ $t('$General.DownloadAs') }}</p>
      <vx-tooltip text="PNG image" position="bottom" class="mr-5">
        <i class="far fa-file-image text-2xl cursor-pointer" @click="downloadAsImage"></i>
      </vx-tooltip>
      <vx-tooltip text="PDF document" position="bottom">
        <i class="far fa-file-pdf text-2xl cursor-pointer" @click="downloadAsPDF"></i>
      </vx-tooltip>
    </div>
    <div class="flex justify-center mt-3">
      <p><a :href="waitingListFormPath" class="link-primary" target="_blank">{{ $t('$General.VisitForm') }}<i class="fas fa-external-link-alt text-sm cursor-pointer ml-2"></i></a></p>
      
    </div>

  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import { mapGetters } from 'vuex';
import jsPDF from 'jspdf';

export default {
  name: 'WaitingListQRCode',
  components: {
    QrcodeVue,
    VxTooltip: () => import('@/layouts/components/vx-tooltip/VxTooltip.vue'),
  },
  props: {
    size: {
      type: Number,
      required: false,
      default: 300,
    },
  },
  computed: {
    ...mapGetters({
      tenantUrlLinksSuffix: 'auth/tenantUrlLinksSuffix',
    }),
    waitingListFormPath() {
      const dashboardUrl = this.$enums.AppLinks.DASHBOARD;
      const baseUrl = dashboardUrl.endsWith('/') ? dashboardUrl : `${dashboardUrl}/`;
      return `${baseUrl}waitlist/${this.tenantUrlLinksSuffix}`;
    },
  },
  methods: {
    downloadAsImage() {
      const canvas = this.$refs.qrCodeCanvas.$el.querySelector('canvas');
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = 'qr-code.png';
      link.click();
    },
    downloadAsPDF() {
      const canvas = this.$refs.qrCodeCanvas.$el.querySelector('canvas');
      const image = canvas.toDataURL('image/png');

      const pdf = new jsPDF();

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = 100;
      const imgHeight = 100;

      const x = (pageWidth - imgWidth) / 2;
      const y = (pageHeight - imgHeight) / 2;

      pdf.addImage(image, 'PNG', x, y, imgWidth, imgHeight);

      pdf.save('qr-code.pdf');
    },
  },
};
</script>

<style scoped lang="scss">
</style>
